export const OPPORTUNITY_ID_PARAM = 'opportunityId';

export const MEMBER_DETAILS_PATH = '/intake-v2/member-details';
